import { configureStore } from '@reduxjs/toolkit'
import loaderReducer from './features/loader/loaderSlice'

export default configureStore({
  reducer: {
    loader: loaderReducer,
  },
})